<template>
    <div class="field is-grouped">
        <p class="control">
            <button
                class="button"
                :class="{'is-loading' : isRequestInProgress}"
                @click.prevent="loadMore"
            >
                {{ trans.load_more_comments_button }}
            </button>
        </p>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "LoadCommentsButton",
    computed: {
        ...mapGetters('comment',
            [
                'isRequestInProgress',
                'trans',
                'paginationSummary',
            ]),
    },
    methods: {
        ...mapActions('comment',
            [
                'loadComments',
                'setRequestInProgress',
            ]),
        loadMore() {
            this.loadComments();
        },
    },
}
</script>

<style lang="scss" scoped>
    @import 'resources/sass/variables.scss';

    .control {
        width: 100%;
    }
    .button {
        padding-top: 12px;
        padding-bottom: 12px;
        width: 100%;
        height: auto;
        color: $info;
        &:hover {
            background-color: #FAFAFA;
            color: $info;
        }
    }
</style>